import React, { useEffect, useState,useContext,useRef, useCallback, use } from "react";
import Vitrine from "./Vitrine";
import Filtres from "./filtres/Filtres";
import {BrowserView, MobileView,isMobile, isBrowser} from 'react-device-detect';
import { AppContext, UserContext } from "../../AppContextProvider";
import { VitrineContext } from "./VitrineContext";
import Une from "../une/Une";
import { useFetch } from "../api/FetchApiData";
import ChatBot from "../chatbot/ChatBot";
import { useInfiniteScroll } from "../utils/InfiniteScroll";
import { useNavigate } from "react-router-dom";
import { useWindowHeight } from "@react-hook/window-size";
import DivLoader from "../utils/Loaders/DivLoader";
import { useTranslation } from "react-i18next";
if (isMobile)
    import('./vitrines_mob.css').then(() => {});
else
    import('./vitrines.css').then(() => {});

export default function Vitrines()
{
    const [UserState,setUserState] = useContext(UserContext);
    const fetchData = useFetch();
    const [vitrines,setVitrines] = useContext(VitrineContext);
    const [AppState,setAppState] = useContext(AppContext);
    const navigator = useNavigate();
    const height = useWindowHeight();
    const [hasMore,setHasMore] = useState(false);
    const [loading,setLoading] = useState(true);
    const {t} = useTranslation();
    const [PricesHistogram,setPricesHistogram] = useState({reloaded:true,histogram:{}});

    const FetchVitrines = useCallback(async ()=>{
        if (!hasMore)
            return
        let params = new URLSearchParams({
            page:vitrines.page,
        });
        Object.keys(vitrines.filters).map((key)=>{
            params.append(key,vitrines.filters[key])
        })
        fetchData.GetData(`vitrines/?${params}`).then((result)=>{
            if(result===undefined)
                {setHasMore(true);return}
            if(result.result && vitrines.page>=result.maxpage)
            {
                if(vitrines.page>=result.maxpage)
                {setHasMore(false);setLoading(false);}           
                if(PricesHistogram.reloaded)
                {
                    setVitrines({...vitrines,page:vitrines.page+1,articles:[...vitrines.articles,...result.vitrines],histogram:result.histogram});
                    setPricesHistogram({reloaded:false,histogram:result.histogram});
                }
                else
                {
                    setVitrines({...vitrines,page:vitrines.page+1,articles:[...vitrines.articles,...result.vitrines]});
                }
            }
        });
        
    },[hasMore])

    const LoadMoreRef = useInfiniteScroll(FetchVitrines,hasMore);

    const BtnNewItem = ()=>
    {
        if(UserState.is_staff)
            return(
                <div style={{textAlign:'center',width:'100%',marginTop:'10px'}}>
                    <input onClick={e=>{navigator('/add-product/')}} className="AddItem" type="button" value={t('vitrines.nouvel-article')} />
                    <input style={{backgroundColor:'lightblue',marginLeft:'5px'}} onClick={e=>{navigator('/promos/')}} className="AddItem" type="button" value={t('vitrines.promo')} />
                </div>
            );
        else
            return
    }
    
    const Page=()=>
    {
        return(
            <div style={{width:'100%',margin:'auto'}}>
                <MobileView>
                    {BtnNewItem()}
                </MobileView>
                {vitrines.articles.map((item,index)=>{    
                    return <Vitrine key={index} article={item} />;
                })}  
                <div ref={LoadMoreRef} style={{height:'20px',width:'100%'}}>
                    <DivLoader style={{width:'100px'}} loading={loading}/>
                </div>
            </div>
        );
    }

    useEffect(()=>{
        //FetchVitrines();
        const LoadLocalFilters = ()=>{
            let _filters_ = {...vitrines.filters};
            let _filters = localStorage.getItem('filters');
            let HomeCharges = localStorage.getItem('home_charges');
            if(!!_filters)
            {
                try{
                    _filters = JSON.parse(_filters_).filters;
                    _filters_ = {..._filters_,_filters};
                }
                catch{}
            }

            if(!!HomeCharges)
            {
                HomeCharges = JSON.parse(HomeCharges);
                let power = 0;
                let capacite = 0;
                HomeCharges.forEach(char=>{
                    power = char.power * char.quantity + power;
                    if(char.night_use)
                        capacite = (power)*char.duration*char.quantity + capacite;
                });
                const ad_filter = {capacite:capacite, puissance:power};
                _filters_ = {..._filters_,advanced:JSON.stringify(ad_filter)}
            }
            setVitrines({articles:[],filters:_filters_,page:1});
        };
        LoadLocalFilters();
        //setVitrines({articles:[],filters:_filters_,page:1});
        //setHasMore(true);
        //setVitrines({...vitrines,reload:()=>{setHasMore(true)}})
    },[])
    
    useEffect(()=>{
        if(!hasMore)
        {
            setLoading(true);
            setHasMore(true);
        }
    },[vitrines.filters])
    
    useEffect(()=>{
        if(!hasMore)
        {
            setVitrines(prev => ({...prev,page:1,articles:[]}));
            setPricesHistogram(prev => ({ ...prev, reloaded: true }));
            setHasMore(true);
        }
    },[AppState.settings.devise,AppState.settings.lang])

    return(
        <div id="Vitrines">
            <BrowserView>
                <Une />
                <div style={{height:'max-content'}}> 
                    <div id="Filtres">
                        {BtnNewItem()}
                        <Filtres />
                    </div>
                    <div id="Produits" style={{flex: 1 }}>
                        {Page()}
                    </div>
                </div>
                <ChatBot />
            </BrowserView>
            <MobileView>
                <div id="Produits" style={{minHeight:height}}>
                    <Une /> 
                    {Page()}
                </div>
            </MobileView>
        </div>
    );
}
